import React from 'react';
import { useModal } from './ModalContext';
export const CallToAction = () => {
  const {
    openTalkToUs
  } = useModal();
  return <section id="cta" className="relative w-full overflow-hidden bg-white py-section-mobile md:py-section-desktop" data-id="element-53" data-mp="1i2a7pptk97cb">
      <div className="container" data-id="element-54" data-mp="14b56ijajo6zv">
        <div className="relative mx-auto max-w-6xl overflow-hidden rounded-2xl bg-gradient-to-br from-primary-50 via-white to-cyan-50/70 px-6 py-10 sm:px-10 md:py-12" data-id="element-55" data-mp="19a8bk3qiyd7u">
          <div className="pointer-events-none absolute -right-28 -top-32 h-80 w-80 rounded-full bg-cyan-200/25 blur-3xl" data-id="element-56" data-mp="ufbvx5gdynkq" />

          <div className="relative grid items-center gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-57" data-mp="lcj513b48dvf">
            <div className="lg:col-span-8" data-id="element-58" data-mp="levq3pc674cp">
              <p className="mb-4 text-sm font-semibold uppercase tracking-[0.16em] text-primary-600" data-id="element-59" data-mp="qcniekgq8shf">
                Bring Nisa to your schools
              </p>
              <h2 className="max-w-2xl text-balance font-serif text-h2-mobile font-normal leading-tight text-cyan-950 md:text-h2-desktop" data-id="element-60" data-mp="2kpn8x8mnb73h">
                Strengthen instructional coaching across your school or district
              </h2>
              <p className="mt-5 max-w-xl text-[17px] leading-relaxed text-gray-600" data-id="element-61" data-mp="25uxdnvi079dc">
                Coaches keep a thread with every teacher. Leaders see what the
                program needs. Neither has to chase the other for it.
              </p>

              <div className="mt-8" data-id="element-62" data-mp="1qypy58hjiw4e">
                <button type="button" onClick={openTalkToUs} className="inline-flex min-h-12 w-full items-center justify-center rounded-xl bg-primary-700 px-7 py-3 font-medium text-white shadow-sm transition-colors duration-200 hover:bg-primary-800 focus-visible:ring-primary-600 sm:w-auto" data-id="element-63" data-mp="1qzradgaalonp">
                  Request a demo
                </button>
              </div>

              
            </div>

            <div className="lg:col-span-4" data-id="element-64" data-mp="3cazt8u241md9">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tgogRyhacp8wRnoA9dF3J4/Nisa_-_Plant_Arc_Growth.png" alt="" aria-hidden="true" className="mx-auto w-40 opacity-80 sm:w-48 lg:ml-auto lg:mr-0 lg:w-full lg:max-w-[220px]" loading="lazy" data-id="element-65" data-mp="3cdvogamkpwy0" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};